// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"670":"d3b3398902d91359","2888":"a67075c42a4cc799"}[chunkId] + ".css";
};